import {Button, Modal, ModalFooter} from 'react-bootstrap'
import {ReleaseNoteModalContent} from './ReleaseNoteModalContent'
import {Link, useSearchParams} from 'react-router-dom'
import {useEffect} from 'react'
import {useMutation, useQuery} from 'react-query'
import {getReleaseNote} from './core/_requests'
import {ReleaseNote} from './core/_models'
import {useAuth} from '../../../../app/modules/auth'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export function ReleaseNoteModal() {
  const [searchParams, setSearchParams] = useSearchParams()
  const releaseNoteId = searchParams.get('releaseNoteId')
  const {currentUser} = useAuth()

  useEffect(() => {
    if (currentUser?.unread_notifications && currentUser.unread_notifications.length > 0) {
      const releaseNoteNotification = currentUser.unread_notifications.find(
        (item) => item.data.type == 'Nota de Lançamento'
      )

      if (releaseNoteNotification) {
        const newParams = new URLSearchParams(searchParams)
        newParams.set('releaseNoteId', String(releaseNoteNotification.data.id))
        setSearchParams(newParams)
      }

      currentUser.unread_notifications.map((notification) => {
        if (notification.data.type == 'Nota de Lançamento') readNotificationsFn(notification.id)
      })
    }
  }, [currentUser?.unread_notifications])

  const {mutateAsync: readNotificationsFn} = useMutation((id: number) => {
    return axios.patch(`${API_URL}/api/notifications/${currentUser?.id}/mark-as-read`, {
      notificationIds: [id],
    })
  })

  function useGetReleaseNote() {
    const fetcher = async () => await getReleaseNote(String(releaseNoteId))
    const queryResult = useQuery(['releaseNote', releaseNoteId], fetcher, {
      enabled: !!releaseNoteId,
      retry: false,
    })

    return {...queryResult, data: queryResult.data ?? ({} as ReleaseNote)}
  }

  const {data: releaseNote} = useGetReleaseNote()

  function handleClose() {
    const newParams = new URLSearchParams(searchParams)
    newParams.delete('releaseNoteId')
    setSearchParams(newParams)
  }

  return (
    <Modal
      className='px-md-5'
      id='kt_modal_adjust_time'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={!!releaseNoteId && !(Object.keys(releaseNote).length === 0)}
      dialogClassName='mw-600px modal-dialog-centered'
      onHide={handleClose}
    >
      <ReleaseNoteModalContent handleClose={handleClose} releaseNote={releaseNote} />

      {!!currentUser?.administrator &&
        currentUser?.instance?.isFree &&
        !currentUser?.instance?.isTrial &&
        releaseNote.cta_text && (
        <ModalFooter className='d-flex justify-content-between'>
          {releaseNote.cta_text}{' '}
          <Link to='/billings'>
            <Button size='sm' variant='primary'>
              Fazer upgrade
            </Button>
          </Link>
        </ModalFooter>
      )}
    </Modal>
  )
}
